import { IconChevronDownSmall } from '@hubble/icons';
import * as ToolbarPrimitive from '@radix-ui/react-toolbar';
import React__default from 'react';
import { Menu } from '../Menu/index.js';
import { Text } from '../Text/index.js';
import { StyledToolbarToggleGroup, StyledToolbarToggleButton, StyledMenuButton, StyledToolbarLink, StyledToolbarRoot, StyledToolbarButton, StyledToolbarSeperator } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const ToolbarToggleGroup = React__default.forwardRef(({
  children,
  ...props
}, ref) => jsx(StyledToolbarToggleGroup, {
  ref: ref,
  ...props,
  children: children
}));
const ToolbarToggleButton = React__default.forwardRef(({
  children,
  value,
  disabled = false,
  ...props
}, ref) => jsx(ToolbarPrimitive.ToggleItem, {
  ref: ref,
  asChild: true,
  value: value,
  disabled: disabled,
  children: jsx(StyledToolbarToggleButton, {
    ...props,
    children: children
  })
}));
const ToolbarMenuButton = React__default.forwardRef(({
  children,
  label,
  width,
  size,
  ...props
}, ref) => jsxs(Menu, {
  ...props,
  children: [jsx(Menu.Trigger, {
    ref: ref,
    children: jsxs(StyledMenuButton, {
      size: size,
      width: width,
      children: [jsx(IconChevronDownSmall, {}), label]
    })
  }), jsx(Menu.Content, {
    children: children
  })]
}));
const ToolbarLink = React__default.forwardRef(({
  children,
  size = 'sm',
  ...props
}, ref) => jsx(ToolbarPrimitive.Link, {
  ref: ref,
  asChild: true,
  children: jsx(StyledToolbarLink, {
    size: size,
    children: jsx(Text.Link, {
      ...props,
      children: children
    })
  })
}));
const Toolbar = Object.assign(StyledToolbarRoot, {
  Button: StyledToolbarButton,
  Seperator: StyledToolbarSeperator,
  Toggle: ToolbarToggleGroup,
  ToggleButton: ToolbarToggleButton,
  Menu: ToolbarMenuButton,
  Link: ToolbarLink
});

export { Toolbar };
